import { colors } from "./colors";
import { radius } from "./radius";

type InputBackgroundParams = {
  disabled?: boolean;
  hasValue?: boolean;
};

const getInputBackgroundColor = ({ disabled, hasValue }: InputBackgroundParams) =>
  disabled && hasValue ? colors.bg.elevation.tertiary : colors.bg.elevation.primary;

const inputBorderColor = colors.border.secondaryDefault;
const inputFocusBorderColor = colors.border.primaryDefault;
const inputErrorBorderColor = colors.border.error.primary;
const inputRadius = radius.xs;

const getInputBorderColor = ({ disabled, hasValue }: InputBackgroundParams) =>
  disabled && !hasValue ? colors.border.secondaryDisabled : inputBorderColor;

const getInputTextColor = ({ disabled, hasValue }: InputBackgroundParams) =>
  disabled && !hasValue ? colors.text.primaryDisabled : colors.text.primaryDefault;

type InputErrorStyleParams = {
  hasValue?: boolean;
};

const getInputErrorBackgroundColor = ({ hasValue }: InputErrorStyleParams) =>
  hasValue ? colors.bg.elevation.primary : colors.bg.status.error.primary;

const getInputErrorShadow = ({ hasValue }: InputErrorStyleParams) =>
  hasValue ? `0 0 0 0.5px ${inputErrorBorderColor}` : "none";

export {
  getInputBackgroundColor,
  getInputBorderColor,
  getInputErrorBackgroundColor,
  getInputErrorShadow,
  getInputTextColor,
  inputBorderColor,
  inputErrorBorderColor,
  inputFocusBorderColor,
  inputRadius,
};
